import { media, Optional } from '@hg/stylizator/utils'
import * as React from 'react'
import { useCookies } from 'react-cookie'
import styled from 'styled-components'

import CookieConsentCard from 'app/components/CookieConsent/CookieConsentCard'
import { IFields } from 'app/components/CookieConsent/Fields'
import { useGlobalState } from 'app/store'

const CookieConsentWrapper: React.FC = () => {
  const [blocks] = useGlobalState('reusableBlocks')
  const consentBlock = blocks.get('honeygain-components/cookie-consent')

  const [cookies, _setCookie] = useCookies(['cookieConsent'])
  const cookieConsentFields: Optional<IFields> = cookies.cookieConsent

  if (
    !consentBlock ||
    (cookieConsentFields &&
      (cookieConsentFields.submitAudienceData ||
        cookieConsentFields.submitBasicData ||
        cookieConsentFields.submitUsageStats))
  ) {
    return null
  }

  return (
    <Wrapper>
      <CookieConsentCard />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  max-width: 1130px;
  z-index: 99999;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 48px);

  @media ${media.tablet}, ${media.mobile} {
    width: calc(100% - 16px);
    bottom: -16px;
  }
`

export default CookieConsentWrapper
